export { default as Header } from 'subcompanies/components/SubcompaniesHeader';
export { default as DeleteModal } from 'subcompanies/components/SubcompanyDeleteModal';
export { default as Element } from 'subcompanies/components/SubcompanyElement';
export { default as Form } from 'subcompanies/components/SubcompanyForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/components/index.js